import { format } from "date-fns";
import { de } from "date-fns/locale";

import { useTranslation } from "react-i18next";
import { minusIcon } from "../../../../../assets/svgs/icons/icons.svg";
import { Disponibilite } from "../../../../../schemas-and-types/etablissement/etablissemen.schema";
import styles from "./MetierRecap.module.scss";

type JourBoxProps = {
  disponibilite: Disponibilite;
  jourIndex: number;
};
export default function JourBoxRecap(props: JourBoxProps) {
  const { disponibilite } = props;
  const { t } = useTranslation()
  return (disponibilite && disponibilite.nombre_professionnel_disponible !== 0) ? (
    <article className={styles.metier__jourBox}>
      <section className={styles.metier__jourBox__date}>
        <label>
          {format(new Date(disponibilite.date), "EEEE d MMMM", { locale: de }).replace(/^./, (str) => str.toUpperCase())}
        </label>
      </section>

      <section className={styles.metier__jourBox__info}>
        <label>{t('validation.recapBoxDay.title')}</label>
        <p>{disponibilite.nombre_professionnel_disponible}</p>
      </section>
    </article>
  ) :
    (
      <article className={styles.metier__jourBox}>
        <section className={styles.metier__jourBox__date}>
          <label>
            {format(new Date(disponibilite.date), "EEEE d MMMM", { locale: de }).replace(/^./, (str) => str.toUpperCase())}
          </label>
        </section>

        <section className={styles.metier__jourBox__info}>
          <label>{t('validation.recapBoxDay.title')}</label>
          <p>{minusIcon}</p>
        </section>
      </article>
    );
}
